import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
//icons
import { FaChevronLeft, FaRegUserCircle } from 'react-icons/fa';
//utils
import { formatdateWithTime } from '../../../utils/helpers';
import { toastError, toastSuccess } from '../../../utils/toast'
//components
import Badge from '../../../components/Badge';
import Button from '../../../components/Button';
//services
import { ticketService } from '../../../services/ticketService';

const Ticket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ticket } = location.state || { ticket: null };
  const [loading, setLoading] = React.useState(false);

  const closeTicket = async () => {
    setLoading(true);
    try {
      const { data, error } = await ticketService.closeTicket(ticket.id);
      if (!error) {
        toastSuccess('Ticket cerrado exitosamente');
        navigate('/support');
      }
    } catch (error) {
      console.error('Error al cerrar ticket:', error);
      toastError(error.message || 'Error al cerrar el ticket');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-surface-card border border-white/[0.06] rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex flex-col items-start gap-2">
          <button className="flex items-center gap-2" style={{ color: 'rgb(var(--fg-dim))' }} onClick={() => navigate('/support')}>
            <FaChevronLeft/>
            <span className="text-lg font-semibold" style={{ color: 'rgb(var(--fg))' }}>Ticket de soporte #{ticket?.folio}</span>
          </button>
          <span className="ml-7 font-light text-sm" style={{ color: 'rgb(var(--fg-dim))' }}>Detalles y seguimiento del ticket</span>
        </div>
      </div>
      <div className="flex items-stretch justify-between gap-6 w-[100%]">
        <div className="w-[30%] p-6 rounded-lg" style={{ backgroundColor: 'rgb(var(--fg) / 0.04)', border: '1px solid rgb(var(--fg) / 0.07)' }}>
          <div className="flex flex-col items-center gap-2">
            <span className="text-lg font-medium pb-2 w-full text-start" style={{ color: 'rgb(var(--fg))', borderBottom: '1px solid rgb(var(--fg) / 0.07)' }}>Agente</span>
            <FaRegUserCircle className="my-2" size={150} style={{ color: 'rgb(var(--fg-dim))' }}/>
            <span className="text-lg font-semibold my-2" style={{ color: 'rgb(var(--fg))' }}>{ticket?.project_id?.name}</span>
          </div>
        </div>
        <div className="w-[70%] p-6 rounded-lg" style={{ backgroundColor: 'rgb(var(--fg) / 0.04)', border: '1px solid rgb(var(--fg) / 0.07)' }}>
          <div className="flex flex-col items-center gap-2 w-full">
            <span className="text-lg font-medium pb-2 w-full text-start" style={{ color: 'rgb(var(--fg))', borderBottom: '1px solid rgb(var(--fg) / 0.07)' }}>Información del ticket</span>
            <div className="grid grid-cols-3 gap-2 items-center w-full py-2">
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Folio:</span>
                <span className="text-lg font-semibold my-1" style={{ color: 'rgb(var(--fg))' }}>#{ticket?.folio}</span>
              </div>
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Estado:</span>
                <Badge type="status" value={ticket?.status} />
              </div>
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Fecha de creación:</span>
                <span className="text-lg font-semibold my-1" style={{ color: 'rgb(var(--fg))' }}>{formatdateWithTime(ticket?.created_at)}</span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 items-center w-full py-2">
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Gravedad:</span>
                <Badge type="severity" value={ticket?.severity} />
              </div>
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Tipo:</span>
                <Badge type="type" value={ticket?.type} />
              </div>
              <div className="flex flex-col items-start py-2">
                <span className="text-lg font-light my-1" style={{ color: 'rgb(var(--fg-dim))' }}>Fecha de cierre:</span>
                <span className="text-lg font-semibold my-1" style={{ color: 'rgb(var(--fg))' }}>{ticket?.closed_date ? formatdateWithTime(ticket?.closed_date) : 'Sin cerrar'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6 rounded-lg mt-6 w-[100%]" style={{ backgroundColor: 'rgb(var(--fg) / 0.04)', border: '1px solid rgb(var(--fg) / 0.07)' }}>
        <div className="flex flex-col items-center gap-2 w-full">
          <span className="text-lg font-medium pb-2 w-full text-start" style={{ color: 'rgb(var(--fg))', borderBottom: '1px solid rgb(var(--fg) / 0.07)' }}>Comentarios</span>
          <div className="flex flex-col items-center gap-2 w-full">
            <div className="flex flex-col items-justify gap-2 w-full">
              <p className="text-lg font-semibold my-1" style={{ color: 'rgb(var(--fg))' }}>{ticket?.description}</p>
            </div>
          </div>
        </div>
      </div>
      {ticket?.status === 'open' && (
        <div className="p-6 mt-6 w-[100%] flex items-center justify-end">
          <Button
            type="button"
            className="rounded-[40px] w-[25%]"
            disabled={loading}
            variant="primary"
            size="md"
            onClick={() => closeTicket()}
          >
            {loading ? 'Cerrando ticket...' : 'Cerrar ticket'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default Ticket